module.exports = __webpack_public_path__ + "img/noun-standardization-5136493.6ce04b58.svg";